export const DEFAULT_ITEM_QUANTITY = 1;
export const ZERO_ITEM_QUANTITY = 0;
